import { QuoteMarkers } from "@atoms/QuoteMarkers";
import { PlanContainerHeader } from "@organisms/PlanContainerHeader";
import { PlanFooter } from "@organisms/PlanFooter";
import { PlanBody } from "@/components/organisms/PlanBody";
import { quotesPosition } from "@/shared/quotesMarkers";
import { planProps } from "./variables";

export const Plans = () => {
  const PlansElement = document.createElement("div");
  PlansElement.className = "border border-gray-100 relative md:app-container";

  quotesPosition.forEach((position) => {
    PlansElement.appendChild(QuoteMarkers(position));
  });

  PlansElement.appendChild(
    PlanContainerHeader({
      onClickChangePlan: (planClicked) => {
        const PlanBodyElement = document.getElementById("plan-body");

        if (PlanBodyElement)
          PlansElement.replaceChild(
            PlanBody({ plan: planProps[planClicked] }),
            PlanBodyElement,
          );
      },
    }),
  );

  PlansElement.appendChild(PlanBody({ plan: planProps.B2C }));

  PlansElement.appendChild(PlanFooter());

  return PlansElement;
};
